// extracted by mini-css-extract-plugin
export default {"noticeIcon":"InfoTooltip_noticeIcon__rs27c","tooltip":"InfoTooltip_tooltip__6TvxY"};